import GallectionSimpleView from './GallectionSimpleView';
import GallectionSimpleViewContainer from './GallectionSimpleView.container';

export default GallectionSimpleViewContainer(
  GallectionSimpleView
);
